<div
  class="offers p-2"
  [class.credit]="isCreditOffer()"
  [class.loan]="isLoanOffer()"
  [class.bg-oat-900]="isResumeAppOffer()"
  [class.bg-white]="!isResumeAppOffer()"
>
  @if (isLoanOffer()) {
    <app-loan-offer
      [offer]="offer()"
      [isInCarousel]="isInCarousel()"
    ></app-loan-offer>
  }
  @if (isCreditOffer()) {
    <app-credit-offer [offer]="offer()"></app-credit-offer>
  }
</div>
